// import axios from "axios";

// // import axios from "axios";
// export default axios.create({
//     // baseURL:'http://192.168.7.108/ITManagementQA/api'
//     // http://192.168.7.108/ResourcePlanning/'
//     // baseURL:'http://192.168.7.108:8090/api',
//     baseURL:'http://192.168.7.32:81/api'
//     // http://192.168.7.32:81/swagger/index.html

// })

import axios from "axios";
import { toast } from "react-toastify";
// Axios instance for the login endpoint
export const loginClient = axios.create({
  //   baseURL: "https://localhost:7133/api", // Base URL for the login API https://localhost:7133/api/Account/Login
  baseURL: process.env.REACT_APP_LOGIN_URL, // Base URL for the login API https://localhost:7133/api/Account/Login
  headers: {
    "Content-Type": "application/json", // Ensure requests use JSON
  },
  withCredentials: true, // Include credentials in requests
});

loginClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;
    // If token expired (401), retry with a refreshed token
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      localStorage.clear();
      window.location.href = "/login";
      const expirationTime = new Date(new Date().getTime() - 1).toUTCString(); // 5 minutes from now
      document.cookie = `CASAuthCookie=; path=/; secure=true; samesite=None; expires=${expirationTime}`;
    } else if (error.response?.status === 403) {
      toast.error("Access Denied!");
    } else if (error?.response?.data?.message === "Token not found.") {
      localStorage.clear();
      const url = window.location.href;
      const lastSegment = url.split("/").filter(Boolean).pop();
      if (lastSegment !== "login") window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Default Axios instance for general API usage
const apiClient = axios.create({
  // Uncomment and use the appropriate baseURL as needed
  // baseURL: 'http://122.185.82.218/PMTOOLSAPI/api',
  // baseURL: 'http://192.168.7.108/ResourcePlanningQA/api',
  // baseURL: 'https://pmtapi.vofox.com/api',
  // baseURL: 'http://192.168.7.108/ResourcePlanning/api',
  // baseURL: 'https://pmapidemo.vofox.com/api',
  // baseURL: 'https://pmtapi.vofoxsolutions.com/api',

  //   baseURL: "https://localhost:44370/api", // Current base URL for general API usage
  baseURL: process.env.REACT_APP_API_URL, // Current base URL for general API usage
  withCredentials: true, // Include credentials in requests
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      toast.error("Session Expired!");
      localStorage.clear();
      window.location.href = "/login";
    } else if (
      error.response?.status === 403 ||
      error.response?.status === 405
    ) {
      toast.error("Access Denied!");
    } else if (error.response?.status === 500) {
      toast.error("Server Error! Please try again later.");
    }
    return Promise.reject(error);
  }
);

export default apiClient;
